/**
 * 인생상회 장부 (시안 09 · 08 K4 ~ K6, 08 결정 28, D53). 생일은 폼이 아니라 대화 속 장부로 받습니다.
 *
 *   왼쪽 40, --surface, hairline, 반경 16, 패딩 16, 간격 12. 머리: 찻잔 마크 20 + 「인생상회 장부」(12/600 --brand)
 *   → 줄 셋(최소 40, 아래 점선): 이름 · 늘 마시는 차 · 생일(비면 「비어 있어요」)
 *   → [적어 주세요](주요) [다음에요](보조) — 누르면 같은 카드가 그 자리에서 생일 폼으로 펼쳐짐(240ms) → 「장부에 적기」
 *
 * - 적은 뒤에도 생일 줄이 채워진 채 대화에 남습니다. 「다음에요」면 버튼 줄이 접힙니다
 * - 펼쳐질 때 첫 입력에 포커스(08 8장)
 */
import { useEffect, useRef } from 'react';
import { BrandMark } from '../../components/Brand.jsx';
import { BirthForm } from '../../components/birth/BirthForm.jsx';

function Row({ label, value }) {
    return (
        <div className="flex min-h-10 items-center gap-2 border-b border-dashed border-[rgba(38,35,31,0.16)] last:border-b-0">
            <span className="w-[72px] shrink-0 text-[13px] text-text-secondary">{label}</span>
            {value ? (
                <span className="font-serif text-[16px] font-bold">{value}</span>
            ) : (
                <span className="text-[14px] text-label-muted">비어 있어요</span>
            )}
        </div>
    );
}

/**
 * @param {{ ledger: { displayName: string, tea: string|null, birth: string|null, status: string },
 *   step: string, busy: boolean, onAccept: () => void, onDecline: () => void, onSubmitBirth: (birth) => void }} props
 */
export function LedgerCard({ ledger, step, busy, onAccept, onDecline, onSubmitBirth }) {
    const formRef = useRef(null);
    const open = step === 'birth' && ledger.status === 'accepted';
    const offering = step === 'offer' && ledger.status === 'shown';

    useEffect(() => {
        if (open) {
            formRef.current?.querySelector('input, select, button')?.focus();
        }
    }, [open]);

    return (
        <section
            aria-label="인생상회 장부"
            className="ml-10 flex flex-col gap-3 rounded-card border border-hairline bg-surface p-4"
        >
            <span className="flex items-center gap-1.5">
                <BrandMark size={20} />
                <span className="text-[12px] font-semibold tracking-[0.06em] text-brand">인생상회 장부</span>
            </span>
            <div className="flex flex-col">
                <Row label="이름" value={ledger.displayName} />
                <Row label="늘 마시는 차" value={ledger.tea} />
                <Row label="생일" value={ledger.birth} />
            </div>
            {offering ? (
                <div className="flex gap-2">
                    <button
                        type="button"
                        disabled={busy}
                        onClick={onAccept}
                        className="h-11 flex-1 rounded-[12px] bg-brand text-[15px] font-semibold text-on-brand disabled:opacity-40"
                    >
                        적어 주세요
                    </button>
                    <button
                        type="button"
                        disabled={busy}
                        onClick={onDecline}
                        className="h-11 flex-1 rounded-[12px] border border-brand text-[15px] font-semibold text-brand disabled:opacity-40"
                    >
                        다음에요
                    </button>
                </div>
            ) : null}
            {open ? (
                <div ref={formRef} className="motion-safe:animate-dim-in">
                    <BirthForm busy={busy} submitLabel="장부에 적기" onSubmit={onSubmitBirth} />
                </div>
            ) : null}
        </section>
    );
}
